import validateFields from './validation';

const CONTAINER = '.js-step-container';
const BUTTON_NEXT_STEP = '.js-btn-next-step';
const BUTTON_PREV_STEP = '.js-btn-prev-step';
const BUTTON_FORM_SUBMIT = '.js-form-submit';
const BUTTON_FORM_SEND = '.js-form-send';
const DATA_STEP = 'data-step';
const DATA_VALDIATE_STEP = 'data-validate-step';
const DATA_NO_RECAPTCHA = 'data-no-recaptcha';

const recaptchaEnabled = window.gon && window.gon.global.recaptcha?.recaptchaEnabled;
const didomiEnabled = window.gon && window.gon.global.recaptcha?.didomiEnabled;

const currentStep = btn => $(btn).closest(`[${DATA_STEP}]`);
const currentContainer = btn => $(btn).closest(CONTAINER);

const isRecaptchaDisabledForContainer = btn => {
  const noRecaptchaFlag = currentContainer(btn).attr(DATA_NO_RECAPTCHA);
  return noRecaptchaFlag === 'true' || noRecaptchaFlag === '1';
};

const canExecuteRecaptcha = () => {
  const recaptchaAllowedByConsent = (recaptchaEnabled && didomiEnabled && window.didomiEnabled && Didomi.getUserStatusForVendor(window.didomiCustomVendorIds.recaptcha)) || (recaptchaEnabled && !didomiEnabled);
  return recaptchaAllowedByConsent && window.grecaptcha && typeof window.grecaptcha.execute === 'function';
};

const validation = (btn, callback) => {
  const $currentStep = currentStep(btn);
  validateFields($currentStep.attr(DATA_VALDIATE_STEP) && !$(btn).is(BUTTON_PREV_STEP) ? $currentStep.find('[data-rule]') : $(), callback);
};

const goToStep = (btn, num) => {
  validation(btn, () => {
    $(btn)
      .closest(CONTAINER)
      .find(`[${DATA_STEP}="${+currentStep(btn).attr(DATA_STEP) + num}"]:first`)
      .removeClass('hidden')
      .siblings(`[${DATA_STEP}]`)
      .addClass('hidden');
  });

  return false;
};

const submitForm = e => {
  e.stopPropagation();

  if (currentStep(e.target).attr(DATA_VALDIATE_STEP) === 'true') {
    e.preventDefault();

    validation(e.target, () => {
      if (isRecaptchaDisabledForContainer(e.target)) {
        e.target.form.submit();
        return;
      }

      // eslint-disable-next-line no-undef
      if (canExecuteRecaptcha()) window.grecaptcha.execute();
      else e.target.form.submit();
    });
  }
};

const sendForm = e => {
  e.stopPropagation();

  if (currentStep(e.target).attr(DATA_VALDIATE_STEP) === 'true') {
    e.preventDefault();

    validation(e.target, () => {
      e.target.form.submit();
    });
  }
};

export const StepScreen = () => {
  window.addEventListener('pageshow', function (event) {
    if (event.persisted && window.grecaptcha && typeof window.grecaptcha.reset === 'function') window.grecaptcha.reset();
  });

  $(CONTAINER).each((idx, el) => {
    const submitFormBtn = $(el).find(`${BUTTON_FORM_SUBMIT}:first`);
    const sendFormBtn = $(el).find(`${BUTTON_FORM_SEND}:first`);

    $(el).find(`${BUTTON_NEXT_STEP}:first`).on('click', ({ target }) => goToStep(target, 1));
    $(el).find(`${BUTTON_PREV_STEP}:first`).on('click', ({ target }) => goToStep(target, -1));
    if (submitFormBtn.length) submitFormBtn[0].addEventListener('click', submitForm, true);
    if (sendFormBtn.length) sendFormBtn[0].addEventListener('click', sendForm, true);
  });
};
